import { render, staticRenderFns } from "./CardOrder.vue?vue&type=template&id=b1db9cba&"
import script from "./CardOrder.vue?vue&type=script&lang=js&"
export * from "./CardOrder.vue?vue&type=script&lang=js&"
import style0 from "./CardOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports